import React from 'react';

import { StyleSheet, View } from 'react-native';

import { Footer as FooterComponent } from 'components/ui';

import { ErrorText } from './error-text';
import { GrandTotalText } from './grand-total-text';
import { PlaceOrderButton } from './place-order-button';
import { CheckoutFooterProps } from './types';

export const CheckoutFooter: React.FC<CheckoutFooterProps> = () => {
  return (
    <FooterComponent>
      <View style={styles.footerContainer}>
        <ErrorText />
        <GrandTotalText />
        <PlaceOrderButton />
      </View>
    </FooterComponent>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    width: '100%',
    maxWidth: 560,
    margin: 'auto',
    alignItems: 'center',
  },
});
